
import * as React from "react";
import CatalogContent from "../components/catalog/catalogContent";
export interface CatalogPageProps {
}
export const CatalogPage = (props: CatalogPageProps) => {
    return (
        <CatalogContent />
    );
}